import { ActiveField, ActiveModel } from '@alt-point/active-models/src'

export class CreateResource extends ActiveModel {
  @ActiveField()
  name?: string = undefined

  @ActiveField()
  ignoreImageCheck?: boolean = false

  @ActiveField()
  file!: File
}
